import React from "react";
import { Button, Grid } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ListProps } from "../../layouts/header/Header";
import { createUseStyles } from "react-jss";
import { GlobalToken } from "antd/es/theme/interface";

const { useBreakpoint } = Grid;

const useStyle = (cardHeight?: string) =>
  createUseStyles<string, GlobalToken>(() => ({
    buttonNavMob: {
      height: "30px !important",
      padding: "4px !important",
      fontSize: "12px !important",
    },
  }))();
type NavigateButtonProps = {
  section: ListProps;
  setSection?: (section: ListProps) => void;
};

const NavigateButton: React.FC<NavigateButtonProps> = ({
  section,
  setSection,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyle();
  const screens = useBreakpoint();
  const clickAction = () => {
    if (setSection) setSection(section);
    navigate(section.link);
  };

  return location.pathname !== section.link ? (
    <Button
      className={screens.xs ? classes.buttonNavMob : ""}
      type={"primary"}
      icon={section.icon}
      onClick={clickAction}
      size="large"
      shape={"round"}
    >
      {section.title}
    </Button>
  ) : (
    <></>
  );
};

export default NavigateButton;
